export const cancelBtnText = 'Cancel';
export const defaultConfirmBtnText = 'Add';
export const assetIdPlaceholder = 'Choose Asset ID';
